<!--
 Copyright 2023, Avation Medical. All rights reserved.
 
 This code is proprietary and confidential information of Avation Medical. Any use, reproduction, modification
 or distribution of the code without the express prior written consent of Avation Medical is strictly prohibited.
-->

<div class="login-page">
    <div class="header login-title">
        <div class="section">
          <button id="backButton" *ngIf="loginMode !=modes.Welcome" class="push-button tertiary backbtn" (click)="handleBack()"><mat-icon svgIcon="back"></mat-icon></button>
          <span style="font-weight: 600;">{{title}}</span>
        </div>
    </div>
    <div class="login-header">
        <img src="/assets/icons/vivally-logo.svg"/>
    </div>

    <div class="login-body">
        <div class="login-text">
            <span *ngIf="loginMode == modes.Welcome">Welcome to the Vivally® System, a wearable bladder control therapy and behavioral health system utilizing neuromodulation to treat patients with urinary urgency and urge urinary incontinence.</span>
            <span *ngIf="loginMode == modes.Existing">Welcome back!</span>
            <span *ngIf="loginMode == modes.New">Tap "Send Access Code" to receive an access code. You will need it to set your password.</span>
            <!-- <span *ngIf="loginMode == modes.Forgot">Please check your email for an access code (including your spam folder) and enter it below. Create a new password that must be at least 8 characters, including one number, one uppercase letter, one lower case letter, and one special character.</span> -->

        </div>

        <div class="login-block">
            <!-- <div class="choice-block">
                <button class="choice-button" [ngClass]="loginMode == modes.Existing ? 'selected' : ''"
                        (click)="changeMode(modes.Existing)">Existing Account</button>
                <button class="choice-button" [ngClass]="loginMode == modes.New ? 'selected' : ''"
                        *ngIf="loginMode != modes.Forgot" (click)="changeMode(modes.New)">New Account</button>
                <button class="choice-button" [ngClass]="loginMode == modes.Forgot ? 'selected' : ''"
                        *ngIf="loginMode == modes.Forgot" (click)="changeMode(modes.Forgot)">Forgot Password</button>
            </div> -->
            
            <form class="login-form" [formGroup]="loginForms[loginMode]" (ngSubmit)="submitForm()">
                <div *ngIf="loginMode == modes.Existing">
                    <div class="form-box">
                        <mat-label>Email Address</mat-label>
                        <mat-form-field>
                            <input id="email" matInput placeholder="somebody@email.com" formControlName="username" >
                        </mat-form-field>
                    </div>
    
                    <div class="form-box">
                        <mat-label>Password</mat-label>
                        <mat-form-field>
                            <input id="password" matInput placeholder="YourPassword123" [type]="hidePassword ? 'password' : 'text'" formControlName="password" >
                            <mat-icon id="visibilityIcon" matSuffix (click)="hidePassword = !hidePassword">{{hidePassword ? 'visibility' : 'visibility_off'}}</mat-icon>
                        </mat-form-field>
                        <div class="error-text" style="margin-bottom: 10px;">
                            <div id="errorStr" *ngIf="errorStr">{{this.errorStr}}</div>
                        </div>
                        <a class="forgot-password" (click)="forgotPassword()">Forgot Your Password?</a>
                    </div>

                    <!-- <div class="spaced">
                        <mat-checkbox id="checkbox" formControlName="rememberPassword">Remember My Password</mat-checkbox>
                    </div> -->
                </div>

                <div *ngIf="loginMode == modes.New">
                    <!-- <div class="login-text">
                        <span>Please enter the email address that was used for</span>
                        <span>registration. We will send you a temporary access code.</span>
                    </div> -->
                    
                <mat-radio-group [style]="{'display': loggedInEmail && loggedInPhoneNumber ? '' : 'none'}" aria-mat-label="Select an option" class="access-code-group" (change)="onAccessCodeChange($event)" [value]="loggedInEmail">
                        <div class="select-access-code">
                            <mat-radio-button *ngIf="loggedInEmail" class="testing-class" value={{loggedInEmail}}>Email access code to {{loggedInEmail}}</mat-radio-button>
                            <mat-radio-button *ngIf="loggedInPhoneNumber" class="testing-class" value={{loggedInPhoneNumber}}>Text access code to {{"*** - "+"*** - "+ loggedInPhoneNumber | maskPhoneNumber}}</mat-radio-button>
                        </div>
                </mat-radio-group>
                <p style="width: 470px;" [style]="{'margin-top': loggedInEmail && loggedInPhoneNumber ? '' : '1em'}">{{accessCodeMsg}}</p>
                    <div class="error-text" style="margin-bottom: 10px;">
                        <div id="errorStr" *ngIf="errorStr">{{this.errorStr}}</div>
                    </div>
                </div>

                <div *ngIf="loginMode == modes.Forgot">
                    <div class="login-text" style="width: 470px;">
                        <span>You will need an access code to set your password. Select where you would like to receive your access code. Than tap “Send Access Code”.</span>
                    </div>
                    <mat-radio-group [style]="{'display': loggedInEmail && loggedInPhoneNumber ? '' : 'none'}" aria-mat-label="Select an option" class="access-code-group" (change)="onAccessCodeChange($event)" [value]="loggedInEmail">
                            <div class="select-access-code">
                                <mat-radio-button *ngIf="loggedInEmail" class="testing-class" value={{loggedInEmail}}>Email access code to {{loggedInEmail}}</mat-radio-button>
                                <mat-radio-button *ngIf="loggedInPhoneNumber" class="testing-class" value={{loggedInPhoneNumber}}>Text access code to {{"*** - "+"*** - "+ loggedInPhoneNumber | maskPhoneNumber}}</mat-radio-button>
                            </div>
                    </mat-radio-group>
                    <p style="width: 470px;color: #1F4C7C;" [style]="{'margin-top': loggedInEmail && loggedInPhoneNumber ? '' : '1em'}">{{accessCodeMsg}}</p>
                    <div class="error-text">
                        <div id="errorStr" *ngIf="errorStr">{{this.errorStr}}</div>
                    </div>
                </div>

                <div *ngIf="loginMode == modes.Welcome">
                    <!-- <div class="login-text">
                        <span>Please enter the email address or phone number that was used for</span>
                        <span>registration. We will send you a temporary access code.</span>
                    </div> -->
                    <div class="login-text spaced">
                        <div class="align">Wondering what Vivally is?
                            <a href="https://avation.com" class="logo-btn vivally-logo-secondary"><img style="height: 1.5em;" src="/assets/icons/ic_vivally_logo_dark.svg"/><span style="font-weight: 500;">Vivally System</span></a>
                        </div>
                    </div>

                    <div class="form-box spaced">
                        <mat-label>Email Address</mat-label>
                        <mat-form-field>
                            <input id="username" matInput placeholder="somebody@email.com" formControlName="username" >
                            <mat-error><app-form-input-error [control]="loginForms[loginMode].get('username')"></app-form-input-error></mat-error>
                        </mat-form-field>
                    </div>

                    <div class="error-text" style="margin-bottom: 10px;">
                        <div id="errorStr" *ngIf="errorStr">{{this.errorStr}}</div>
                    </div>
                </div>

                <div class="login-block" style="margin-top: 0;" *ngIf="!loading; else while_loading">
                    <div class="error-text" style="margin-bottom: 10px;">
                        <div id="waitStr" *ngIf="loginMode != modes.Welcome && loginMode != modes.Existing && waitStr">{{this.waitStr}}</div>
                    </div>
                    <div *ngIf="loginMode !== modes.Existing" class="login-text" style="margin-bottom: 35px;">
                        <span>Contact Avation Medical for any help.</span>
                    </div>
                    <div style="display: flex;gap: 1em;">
                        <button *ngIf="loginMode!=modes.Welcome" id="backButton" (click)="handleBack()" type="button" class="push-button tertiary">Back</button>
                        <button id="signInButton" class="push-button primary" type="submit" [disabled]="!enableSubmit(loginMode)">{{this.buttonText}}</button>
                    </div>
                </div>
                <ng-template #while_loading>
                    <mat-progress-spinner class="progress-spinner" color="primary" mode="indeterminate"></mat-progress-spinner>
                </ng-template>
            </form>
        </div>
    </div>
    <vivally-footer></vivally-footer>
</div>